import { render, staticRenderFns } from "./RegistrationErrorPage.vue?vue&type=template&id=5ebe37a7&scoped=true"
import script from "./RegistrationErrorPage.vue?vue&type=script&lang=js"
export * from "./RegistrationErrorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe37a7",
  null
  
)

export default component.exports